const inputData = (el1, key, value) => {
    el1((current) => {
        let newObject = { ...current };
        newObject[key] = value;
        return newObject;
    });
};

export default inputData;